import { MessageObject } from '@messageformat/react';
import { Locale } from '@op/opds.opux';

const getMessages = async (locale: Locale): Promise<MessageObject> => {
  switch (locale) {
    case 'fi':
      return (await import('./messages_fi.yaml')).default;
    case 'sv':
      return (await import('./messages_sv.yaml')).default;
    case 'en':
      return (await import('./messages_en.yaml')).default;
    default:
      throw new Error(`Unsupported locale: ${locale}`);
  }
};

export default getMessages;
